export default __webpack_public_path__ + "static/media/StoreOffIcon.e4c4b5b3.svg";